import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';

const {yes, no} = translations['pt-br'].commons;

export const radioOptions = [
	{value: true, label: yes, dataTagId: AutoSolEnum.CLICK_SIM_PREFERENCIA_AUTOSOL_SAUDE},
	{value: false, label: no, dataTagId: AutoSolEnum.CLICK_NAO_PREFERENCIA_AUTOSOL_SAUDE},
];
